import { PromoTokenType, PromotionToken } from '@bpos/v1/my-bets';
import { Decimal } from 'decimal.js';

export function getTokenWinningsBoost(token: PromotionToken | undefined): Decimal {
    if (!token || token.tokenType !== PromoTokenType.OddsBoost) {
        return new Decimal(0);
    }

    const winningBoost = token.additionalInformation.informationItems.find((item) => item.key === 'WinningsBoost')?.value ?? '0';

    return new Decimal(winningBoost);
}
